<template>
  <div class="app-container bg-f3f4f7" style="padding: 10px 20px 20px">
    <div class="flex content-top mb-10">
      <div class="flex-1 bg-ff h-100 flex align-center pl-5 mr-10">
        <div class="tab-item active">
          <span class="bg-4-f5971d"></span>
          库存过账期间
        </div>
      </div>
    </div>
    <div class="mb-10 flex">
      <div class="btn-24-bg-ff flex align-center mr-5" @click="onAdd">
        <img src="/static/images/customer/chubeikehu.png" class="icon-14 mr-5" alt="">
        新增
      </div>
      <div class="btn-24-bg-ff flex align-center" @click="onStart">
        <div class="mr-5">
          <i class="el-icon-video-play" style="color: #f5971d; font-size: 14px"></i>
        </div>
        账套启用
      </div>
    </div>
    <div class="flex-1">
      <div class="h-100 flex-column">
        <div class="flex-1 mb-10">
          <div class="h-100">
            <erp-table :table-data="tableData" btn-show-key="status" :loading="isLoading" :column-data="columnData" ref="erpTable" @on-finish="onFinish"
                       @on-modify="onModify" modify-method="on-modify" @on-delete="onDelete" :is-edit="true"></erp-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ErpTable from '../../components/ErpTable'
import Pagination from '../../components/Pagination'
export default {
  name: 'inventoryPeriodrDefine',
  components: {ErpTable, Pagination},
  data () {
    return {
      isLoading: false,
      tableData: [],
      columnData: [
        {
          type: 'selection',
          width: '40',
          fixed: 'left'
        }, {
          field: 'operate',
          title: '操作',
          width: '80',
          fixed: 'left',
          isDefine: true,
          child: [{
            type: 'btn',
            className: 'btn-16-bg-85 mr-5 btn-hover',
            title: '结账',
            methodName: 'on-finish',
            showStatus: 2
          }, {
            type: 'btn',
            className: 'btn-16-bd-ff5555',
            title: '删除',
            methodName: 'on-delete',
            showStatus: 1
          }]
        }, {
          field: 'status',
          title: '期间状态',
          width: '100',
          formatter: 'toInventoryStatus'
        }, {
          field: 'code',
          title: '期间代码',
          width: '150',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'startDate',
          title: '记账开始时间',
          minWidth: '200',
          editType: 'date', // 为日期的编辑
          dateConfig: { // 为日期时必填  用来区分是日期还是日期+时间
            format: 'yyyy-MM-dd',
            type: 'date'
          },
          editRender: {
            name: 'input'
          },
          formatter: ['toDateString', 'yyyy-MM-dd']
        }, {
          field: 'endDate',
          title: '记账结束时间',
          minWidth: '200',
          editType: 'date', // 为日期的编辑
          dateConfig: { // 为日期时必填  用来区分是日期还是日期+时间
            format: 'yyyy-MM-dd',
            type: 'date'
          },
          editRender: {
            name: 'input'
          },
          formatter: ['toDateString', 'yyyy-MM-dd']
        }
      ]
    }
  },
  created () {
    this.getData()
  },
  mounted () {},
  methods: {
    onFinish (row) {
      let that = this
      this.$confirm(`确定要进行结账？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.axios.post('inventoryPeriod/checkOut', {companyId: that.$store.state.companyId, id: row.id}).then(res => {
          if (res.data.success) {
            that.$message.success('结账成功')
            that.getData()
          } else {
            that.$message({
              message: res.data.msg,
              type: 'error',
              offset: 400
            })
          }
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消结账'
        })
      })
    },
    onStart () {
      let that = this
      this.$confirm(`确定要启用？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.axios.post('inventoryPeriod/start', {companyId: that.$store.state.companyId}).then(res => {
          if (res.data.success) {
            that.$message.success('启用成功')
            that.getData()
          } else {
            that.$message({
              message: res.data.msg,
              type: 'error',
              offset: 400
            })
          }
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消启用'
        })
      })
    },
    onDelete (row) {
      let that = this
      this.$confirm(`此操作将永久删除"${row.name}", 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.axios.post('inventoryPeriod/deleteById', that.qs.stringify({id: row.id})).then(res => {
          if (res.data.success) {
            that.$message.success('删除成功')
            that.getData()
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error',
              offset: 400
            })
          }
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    onAdd () {
      let params = {
        companyId: this.$store.state.companyId
      }
      this.axios.post('inventoryPeriod/save', params).then(res => {
        if (res.data.success) {
          this.$refs.erpTable.insertAt(res.data.data, -1, 'code')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onModify (row, column, colName) {
      let params = {
        id: row.id,
        [colName]: row[colName]
      }
      this.axios.post('inventoryPeriod/modify', params).then(res => {
        if (res.data.success) {
          this.$message.success('修改成功')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    getData () {
      this.isLoading = true
      this.axios.post('inventoryPeriod/list', {companyId: this.$store.state.companyId}).then(res => {
        this.isLoading = false
        if (res.data.success) {
          this.tableData = res.data.data
          for (let i = 0; i < this.tableData.length; i++) {
            if (this.tableData[i].status !== 1) {
              this.tableData[i].unEditable = 'ALL'
            }
          }
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .content-top {
    height: 30px;
    .tab-item {
      font-size: 16px;
      color: #272727;
      display: flex;
      align-items: center;
      margin-right: 15px;
      cursor: pointer;
      span {
        height: 16px;
      }
      &.active {
        color: #f5971d;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/systemDefine/inventoryPeriodrDefine.vue